import { LocalStorageKeys } from 'utils/constants';

export const onLogout = () => {
  localStorage.removeItem(LocalStorageKeys.cms_user);
  localStorage.removeItem(LocalStorageKeys.access_token);
  localStorage.removeItem(LocalStorageKeys.expiredTime);
  window.location.href = '/';
};
